const GetGenres=state=> state.genres;

export {
    GetGenres,
}


// WEBPACK FOOTER //
// ./src/modules/genres/store/getters.js